var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdnoklassniki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 22.195C26 24.297 24.305 26 22.215 26H3.785C1.695 26 0 24.297 0 22.195V3.805C0 1.703 1.695 0 3.785 0h18.43C24.305 0 26 1.703 26 3.805v18.39z",
    fill: "#FAAB62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 22.195C26 24.297 24.305 26 22.215 26H3.785C1.695 26 0 24.297 0 22.195V3.805C0 1.703 1.695 0 3.785 0h18.43C24.305 0 26 1.703 26 3.805v18.39z",
    fill: "#ededf1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 6.36a1.86 1.86 0 1 1 0-3.72 1.86 1.86 0 0 1 0 3.72z",
    fill: "#181C32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.643 16.767c1.78-.401 2.848-1.335 2.904-1.385.521-.462.605-1.304.187-1.88-.418-.577-1.179-.67-1.7-.208-.011.01-1.15.976-3.022.978-1.873-.002-3.035-.968-3.046-.978-.521-.462-1.282-.37-1.7.207-.418.577-.334 1.419.187 1.881.057.051 1.168 1.009 2.999 1.4L8.9 19.733a1.44 1.44 0 0 0 .03 1.893c.235.25.538.375.84.375.317 0 .634-.137.87-.41l2.371-2.793 2.61 2.812a1.129 1.129 0 0 0 1.71-.002 1.441 1.441 0 0 0-.001-1.892l-2.688-2.948z",
    fill: "#181C32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.03 14.286c-.005 0 .005 0 0 0-.004 0 .005 0 0 0z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnoklassniki);
export default __webpack_public_path__ + "static/media/odnoklassniki.e08b67a2bc62fe5171f0968d82760b14.svg";
export { ForwardRef as ReactComponent };